// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_COUNTDOWN_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-countdown-widget widget=\"$ctrl.getWidget()\"></gb-edit-countdown-widget> ";
// Exports
export default code;